import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap/dist/css/bootstrap.min.css"; // Import Bootstrap CSS
import "bootstrap"; // Import Bootstrap JS
import "bootstrap-icons/font/bootstrap-icons.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

// Global function to clean up modal backdrop
function cleanupModalBackdrops() {
  console.log("Cleaning up modal backdrops");
  // Remove any modal backdrops
  const backdrops = document.getElementsByClassName('modal-backdrop');
  if (backdrops.length > 0) {
    Array.from(backdrops).forEach(backdrop => {
      if (backdrop.parentNode) {
        backdrop.parentNode.removeChild(backdrop);
      }
    });
  }
  // Reset body styles
  document.body.classList.remove('modal-open');
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}

// Add global backdrop cleanup to window
(window as any).cleanupModalBackdrops = cleanupModalBackdrops;

// Add route change listener to clean up backdrops
router.beforeEach((to, from, next) => {
  cleanupModalBackdrops();
  next();
});

const app = createApp(App);

app.use(store);
app.use(router);
app.use(Toast);

// Make the function available to all components
app.config.globalProperties.$cleanupModalBackdrops = cleanupModalBackdrops;

app.mount("#app");

// Add periodic cleanup every 5 seconds to catch any leftovers
setInterval(cleanupModalBackdrops, 5000);
